<template>
	<div class="processing">
		<div class="processing__loading">
			<div class="body-lg body--highlighted">
				{{ t('processing.title') }}
			</div>
			<HYIcon
				name="Spinner"
				size="lg"
				role="status"
				aria-label="Loading..."
			/>
		</div>
	</div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import { HYIcon } from '@voicemod1/harmony-ui';

const { t } = useI18n();
</script>

<style scoped lang="scss">
.processing {
	position: fixed;

	display: flex;
	flex-direction: column;
	gap: var(--hy-space-3xl);
	align-items: center;
	justify-content: center;

	width: 100%;
	height: 100%;

	background-color: var(--hy-color-alpha-shadow-1000-80);

	&__loading {
		display: flex;
		flex-direction: column;
		gap: 11px;
		align-items: center;
		justify-content: center;

		margin-top: -100px;
	}
}
</style>
